/**
 * intl-tel-input is published as UMD; when bundled, it attaches to module.exports, not window.
 * CA_Phone (iti-phone.js) expects window.intlTelInput — resolve the export and assign before iti-phone runs.
 * Import order in bundle.js must be: this file, then iti-phone.js.
 */
import intlTelInput from 'intl-tel-input';

function getIntlTelInputFactory() {
	if (typeof intlTelInput === 'function') {
		return intlTelInput;
	}
	if (intlTelInput && typeof intlTelInput.default === 'function') {
		return intlTelInput.default;
	}
	if (
		intlTelInput &&
		intlTelInput.default &&
		typeof intlTelInput.default.default === 'function'
	) {
		return intlTelInput.default.default;
	}
	return null;
}

if (typeof window !== 'undefined') {
	var itiFactory = getIntlTelInputFactory();
	if (itiFactory) {
		window.intlTelInput = itiFactory;
	}
}
